<template>
	<label class="fac-radio" :class="[design, { inline: inline }]">
		<input type="radio" :name="name" :value="value" :checked="checked" @change="onChange" />
		<span>{{ label }}</span>
	</label>
	<!-- 
        Modo de uso
        <fieldset>
            <ui-radio @input="radioHandler" name="teste" label="item 1" value="1" />
            <ui-radio @input="radioHandler" name="teste" label="item 2" value="2" />
            <ui-radio @input="radioHandler" name="teste" label="item 3" value="3" />
        </fieldset> 
    -->
</template>
<script>
export default {
	name: 'ui-radio',
	props: {
		/**
		 * Utilize para aplicar as classes do botão
		 */
		value: {
			required: false,
		},
		/**
		 * Utilize para aplicar as classes do botão
		 */
		label: {
			type: String,
			required: false,
		},
		/**
		 * Utilize para aplicar as classes do botão
		 */
		name: {
			type: String,
			required: true,
		},
		/**
		 * Utiliza para aplicar o estado checked no input
		 */
		checked: {
			type: Boolean,
			required: false,
		},
		/**
		 * Utilize para aplicar as classes do botão
		 */
		design: {
			type: String,
			required: false,
		},
		/**
		 * Define se o componente vai estar em linha ou em lista
		 */
		inline: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	methods: {
		onChange(event) {
			this.$emit('input', event.target.value)
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>